/**
 * External Imports
 */
import { FC, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';

/**
 * Nexus Imports
 */
import { NeuIcon } from '@neutron/react';
import { useAnalyticsApi } from '@shared-web-analytics/react/dist';

/**
 * Internal Imports
 */
import { useUserRolesRef } from '../../../services/UserRoles';

import { logTableStart } from '../../../utils/analyticsHelpers';
import { setLastPath } from '../../../utils/helpers';

/**
 * Styling Imports
 */
import {
  IconContainer,
  InlineRelativeContainer,
  PopContent,
  PopItem,
  StyledNavTab,
  ValidationDropDownContainer
} from './NavDropdown.styles';

const ValidationDropdown: FC<{}> = () => {
  const [validationDropdownState, setValidationDropdownState] = useState(false);
  const [, setShowPopover] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { logTrackingEvent } = useAnalyticsApi();

  const {
    isEnterpriseAdmin,
    isValidationRounder,
    isAidetValidationRounder,
    isBssrValidationRounder,
    isSafetyValidationRounder,
    isAllValidationRounder,
    isSupportRounder,
    isNonSupportRounder,
    isMultipleRounders,
    numOfRoles
  } = useUserRolesRef();
  return (
    <>
      {(isEnterpriseAdmin ||
        ((isNonSupportRounder || isSupportRounder) &&
          isAllValidationRounder)) && (
        <>
          <StyledNavTab
            data-testid="validation-tab"
            active={pathname.includes('validation')}
            unit="tab"
            onBlur={() => setValidationDropdownState(false)}
            onClick={() => setValidationDropdownState(!validationDropdownState)}
          >
            <IconContainer>
              Validation
              <NeuIcon color="gray" size="1x">
                arrow_drop_down
              </NeuIcon>
            </IconContainer>
          </StyledNavTab>
          <InlineRelativeContainer onBlur={() => setShowPopover(false)}>
            <ValidationDropDownContainer
              showReportDropdown={validationDropdownState}
            >
              <PopItem
                className="dropdown-hover-item"
                role="option"
                tabIndex={0}
                onMouseDown={() => {
                  setLastPath('/validation/nlr/list');
                  navigate('/validation/nlr/list');
                  logTrackingEvent(logTableStart('/validation/nlr/list'));
                }}
              >
                <PopContent>NLR / STAR Coaching</PopContent>
              </PopItem>
              <PopItem
                className="dropdown-hover-item"
                role="option"
                tabIndex={0}
                onMouseDown={() => {
                  setLastPath('/validation/aidet/list');
                  navigate('/validation/aidet/list');
                  logTrackingEvent(logTableStart('/validation/aidet/list'));
                }}
              >
                <PopContent>AIDET®</PopContent>
              </PopItem>
              <PopItem
                className="dropdown-hover-item"
                role="option"
                tabIndex={0}
                onMouseDown={() => {
                  setLastPath('/validation/bssr/list');
                  navigate('/validation/bssr/list');
                  logTrackingEvent(logTableStart('/validation/bssr/list'));
                }}
              >
                <PopContent>BSSR</PopContent>
              </PopItem>
              <PopItem
                className="dropdown-hover-item"
                role="option"
                tabIndex={0}
                onMouseDown={() => {
                  setLastPath('/validation/safety/list');
                  navigate('/validation/safety/list');
                  logTrackingEvent(logTableStart('/validation/safety/list'));
                }}
              >
                <PopContent>Safety</PopContent>
              </PopItem>
            </ValidationDropDownContainer>
          </InlineRelativeContainer>
        </>
      )}
      {!isEnterpriseAdmin &&
        ((!isMultipleRounders && isValidationRounder) ||
          (numOfRoles === 4 && isAllValidationRounder) ||
          (isMultipleRounders &&
            !isAllValidationRounder &&
            isValidationRounder)) && (
          <Link
            key="NLR-Tab"
            data-testid="nlr-tab"
            to="/validation/nlr/list"
            onClick={() => {
              setLastPath('/validation/nlr/list');
            }}
          >
            <StyledNavTab
              active={
                pathname.includes('validation') && pathname.includes('nlr')
              }
              unit="tab"
            >
              NLR / STAR Coaching
            </StyledNavTab>
          </Link>
        )}
      {!isEnterpriseAdmin &&
        ((!isMultipleRounders && isAidetValidationRounder) ||
          (numOfRoles === 4 && isAllValidationRounder) ||
          (isMultipleRounders &&
            !isAllValidationRounder &&
            isAidetValidationRounder)) && (
          <Link
            key="AIDET-Tab"
            data-testid="aidet-tab"
            to="/validation/aidet/list"
            onClick={() => {
              setLastPath('/validation/aidet/list');
            }}
          >
            <StyledNavTab
              active={
                pathname.includes('validation') && pathname.includes('aidet')
              }
              unit="tab"
            >
              AIDET®
            </StyledNavTab>
          </Link>
        )}
      {!isEnterpriseAdmin &&
        ((!isMultipleRounders && isBssrValidationRounder) ||
          (numOfRoles === 4 && isAllValidationRounder) ||
          (isMultipleRounders &&
            !isAllValidationRounder &&
            isBssrValidationRounder)) && (
          <Link
            key="bssr-tab"
            data-testid="bssr-tab"
            to="/validation/bssr/list"
            onClick={() => {
              setLastPath('/validation/bssr/list');
            }}
          >
            <StyledNavTab
              active={
                pathname.includes('validation') && pathname.includes('bssr')
              }
              unit="tab"
            >
              BSSR
            </StyledNavTab>
          </Link>
        )}
      {!isEnterpriseAdmin &&
        ((!isMultipleRounders && isSafetyValidationRounder) ||
          (numOfRoles === 4 && isAllValidationRounder) ||
          (isMultipleRounders &&
            !isAllValidationRounder &&
            isSafetyValidationRounder)) && (
          <Link
            key="safety-tab"
            data-testid="safety-tab"
            to="/validation/safety/list"
            onClick={() => {
              setLastPath('/validation/safety/list');
            }}
          >
            <StyledNavTab
              active={
                pathname.includes('validation') && pathname.includes('safety')
              }
              unit="tab"
            >
              Safety
            </StyledNavTab>
          </Link>
        )}
    </>
  );
};

export default ValidationDropdown;
